// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ComptabiliteToolbar_button__2kvOz {\n  width: 160px;\n  padding: 8px 0px;\n  min-width: 160px;\n  margin-left: 24px;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Comptabilite/ComptabiliteToolbar.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".button {\n  width: 160px;\n  padding: 8px 0px;\n  min-width: 160px;\n  margin-left: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "ComptabiliteToolbar_button__2kvOz"
};
export default ___CSS_LOADER_EXPORT___;
